import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import ButtonWrapper from "../../../../../components/Button";
import FileUploader from "../../../../../reusableComponents/FileUploader2";
import InputWrapper from "../../../../../layout/inputWrapper";

const OldLandUseCompletion = ({ t, formData, handleSubTabChange, handleTabChange, isEmployee, isApproved }) => {
  const [showError, setShowError] = useState(false);
  const { handleSubmit, control, setValue } = useForm();
  const { documents } = useSelector((state) => state.formMT);
  const userType = Digit.SessionStorage.get("userType");

  console.log("FormDatastats15155515", formData);

  const validateRequiredDocuments = (documents = []) => {
    const requiredTypes = ["drawingPdf", "approvalLetter"];

    return requiredTypes.every((type) => documents.some((doc) => doc.documentType === type));
  };

  useEffect(() => {
    if (formData) {
      if (formData?.layoutsanctionDate) {
        setValue("layoutsanctionDate", formData?.layoutsanctionDate);
      }
      if (formData?.validityDate) {
        setValue("validityDate", formData?.validityDate);
      }
      if (formData?.obpassSanctionDate) {
        setValue("obpassSanctionDate", formData?.obpassSanctionDate);
      }
    }
  }, [formData]);

  const onSubmit = (data) => {
    console.log("DataGOt1y2ty12", data);
    const isValid = validateRequiredDocuments(documents);
    if (!isValid) {
      setShowError(true);
      return;
    } else {
      const finalData = {
        ...formData,
        ...data,
        documents: documents,
      };
      console.log("finalData33312", finalData, documents);
      handleTabChange(1, finalData);
    }
  };

  return (
    <section className="groupContainer3">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Application Details")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  label={t("Previous Sanction date")}
                  control={control}
                  placeholder={t("Enter Previous Sanction date")}
                  name="layoutsanctionDate"
                  // defaultValue={formData?.layoutsanctionDate}
                  type="datePicker"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={userType !== "citizen"}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Previous Sanction Validity date")}
                  control={control}
                  placeholder={t("Enter Previous Sanction Validity date")}
                  name="validityDate"
                  // defaultValue={formData?.validityDate}
                  type="datePicker"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={userType !== "citizen"}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={t("OBPASS Sanction date")}
                  control={control}
                  placeholder={t("Enter OBPASS Sanction date")}
                  name="obpassSanctionDate"
                  // defaultValue={formData?.obpassSanctionDate}
                  type="datePicker"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={userType !== "citizen"}
                />
              </Col>
              <Col></Col>
            </Row>
          </Container>

          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Document")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col className="custom-upload new-custom-uploader">
                <FileUploader
                  isMandatory
                  label={t("Drawing PDF")}
                  control={control}
                  name="drawingPdf"
                  showError={showError}
                  maxFiles={1}
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  required
                />
              </Col>
              <Col className="custom-upload new-custom-uploader">
                <FileUploader
                  isMandatory
                  label={t("Approval Letter")}
                  control={control}
                  maxFiles={1}
                  showError={showError}
                  name="approvalLetter"
                  validationMsg="(pdf file only and Max file Size 30 MB)"
                  required
                />
              </Col>
            </Row>
          </Container>

          <Container fluid className="formInputContainer common-app-form"></Container>
          <div className="footerContainer2">
            {!isEmployee && !isApproved && (
              <div className="buttonWrapper">
                <ButtonWrapper
                  variant="contained"
                  color="error"
                  size="medium"
                  label="Prev"
                  sx={{ backgroundColor: "#CCC", marginRight: "4px" }}
                  onClick={() => handleSubTabChange(2)}
                />
                <ButtonWrapper
                  variant="contained"
                  color="success"
                  size="medium"
                  label="Save"
                  type="submit"
                  sx={{ backgroundColor: "#000", marginRight: "4px" }}
                />
              </div>
            )}
          </div>
        </div>
      </form>
    </section>
  );
};

export default OldLandUseCompletion;
